import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import firebase from "firebase"
import {
  FirebaseAuthProvider,
  IfFirebaseAuthed,
} from "@react-firebase/auth"
import { config } from "../../config"
import { translate } from "react-i18next"
import { Link } from 'gatsby'


class Footer extends React.Component {
  constructor(props) {
    super(props);
  }
    render() {
      const { t } = this.props
      return (
      <StaticQuery
        query={graphql`
          query FooterQuery {
            site {
              siteMetadata {
                author,
                shortTitle,
                facebook,
                instagram,
                twitter,
                xing,
                linkedin,
                admins
              }
            }
          }
        `}
        render={data => (
          <footer id="footer">
            <div className="inner blend-in">
              <ul className="icons">
                <li>
                  <a href={data.site.siteMetadata.twitter} target="_blank" rel="noreferrer" aria-label="Twitter" className="icon alt fa-twitter">
                    <span className="label">Twitter</span>
                  </a>
                </li>
                <li>
                  <a href={data.site.siteMetadata.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="icon alt fa-facebook">
                    <span className="label">Facebook</span>
                  </a>
                </li>
                <li>
                  <a href={data.site.siteMetadata.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="icon alt fa-instagram">
                    <span className="label">Instagram</span>
                  </a>
                </li>
                <li>
                  <a href={data.site.siteMetadata.xing} target="_blank" rel="noreferrer" aria-label="Xing" className="icon alt fa-xing">
                    <span className="label">Xing</span>
                  </a>
                </li>
                <li>
                  <a href={data.site.siteMetadata.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="icon alt fa-linkedin">
                    <span className="label">LinkedIn</span>
                  </a>
                </li>
              </ul>
              <ul className="copyright">
                <li>&copy; Made with <span>🧡</span> by {data.site.siteMetadata.shortTitle}</li>

{/*             <li><a href="/privacy">{t("footer_privacy", "Datenschutzerklärung")}</a></li>
                <li><a href="/imprint">{t("footer_imprint", "Impressum")}</a></li>
                <li><a href="/meeting">{t("footer_meeting", "Meeting")}</a></li> */}

                <li><Link className="" to="/privacy">{t("footer_privacy", "Datenschutzerklärung")}</Link></li>
                <li><Link className="" to="/imprint">{t("footer_imprint", "Impressum")}</Link></li>
                <li><Link className="" to="/meeting">{t("footer_meeting", "Meeting")}</Link></li>
                <li><a href={'/WFOW_Medien.zip'} download>{t("footer_press", "Presse")}</a></li>

                <FirebaseAuthProvider {...config} firebase={firebase}>
                  <IfFirebaseAuthed>
                    {(user) => {
                    var admins = data.site.siteMetadata.admins;
                      if (admins.includes(user.user.email)) {
                        return (
                          // <li><a href="/admin">Admin</a></li>
                          <li><Link className="" to="/admin">Admin</Link></li>
                        )
                      }}}
                  </IfFirebaseAuthed>
                </FirebaseAuthProvider>
              </ul>
            </div>
          </footer>
          )}
        />
     )
  }
} 
export default translate("Index")(Footer)